export default {
    title: 'Organisationsstatus ändern',
    toggleText: 'Möchten Sie die ausgewählten Organisationen aktivieren / deaktivieren?',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren'
}